import React, { useState } from 'react';
import './TooltipInput.css';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const TooltipInput = (props) => {
    const id = props.id;
    const idKey = props.idKey;
    const horas = props.horas;
    const comentario = props.comentario;
    const callbackOnChange = props.onChange;
    const callbackOnClick = props.onClick;
    const disabled = props.disabled;

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {comentario}
        </Tooltip>
    );

    const getInput = (props) => {
        return (
            <input class="text-center input-hours-width grid-no-editable-resumen-row"
                id={id}
                key={idKey}
                type="text"
                min="0"
                max="24"
                step="0.01"
                disabled={disabled}
                defaultValue={horas}
                onChange={callbackOnChange}
            />
        );
    };

    const getOverlayTrigger = (props) => {
        console.log(comentario);
        if (comentario != null && comentario.length > 0) {
            return (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip}
                >
                    { getInput() }
                </OverlayTrigger>);
        }
        else {
            return (getInput());
        }
    }

    return (
        getOverlayTrigger()
    );
}

export default TooltipInput;